const MESSAGE_KEYS = ['error', 'message', 'msg', 'detail', 'description', 'reason'] as const;
const MAX_ERROR_DEPTH = 4;

const parseJsonObject = (value: string): unknown => {
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
};

const extractErrorMessage = (
  value: unknown,
  seen = new WeakSet<object>(),
  depth = 0
): string | undefined => {
  if (depth > MAX_ERROR_DEPTH || value == null) return undefined;
  if (typeof value === 'string') {
    const parsed = parseJsonObject(value);
    return parsed && typeof parsed === 'object'
      ? extractErrorMessage(parsed, seen, depth + 1) ?? value
      : value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) {
    const messages = value
      .map((item) => extractErrorMessage(item, seen, depth + 1))
      .filter(Boolean);
    return messages.length ? messages.join('\n') : undefined;
  }
  if (typeof value !== 'object') return undefined;

  if (seen.has(value)) return undefined;
  seen.add(value);

  const record = value as Record<string, unknown>;
  for (const key of ['responseBody', 'data', 'cause', ...MESSAGE_KEYS]) {
    const message = extractErrorMessage(record[key], seen, depth + 1);
    if (message) return message;
  }

  return undefined;
};

export const parseError = (error: unknown) => {
  if (error instanceof Error) {
    const message = extractErrorMessage(error);
    return message || 'An error occurred';
  }

  return extractErrorMessage(error) || 'An error occurred';
};
